module.exports = __webpack_public_path__ + "static/adult-business-businessman-2182970-47bbb3be880509adb4686a99762cd22d.jpg";